
import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

Swiper.use([Navigation, Pagination])

export const LogoSlider = () => {
  const $sliderWrapper = $('.js-logoSlider__sliderWrapper');
  if ( !$sliderWrapper.length ) {
      return
  }

  $(document).ready(function() {
    new Swiper('.js-logoSlider__sliderWrapper', {
      slidesPerView: 2,
      spaceBetween: 30,
      pagination: {
        clickable: true,
      },

      breakpoints: {
        576: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
      },
  
      // Navigation arrows
      navigation: {
        nextEl: '.js-logoSlider__nextSlide',
        prevEl: '.js-logoSlider__prevSlide',
      },
    })
  })
}